import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Option from './Option';
import {OptionGroupWrapper, OptionGroupStyled, OptionGroupName, OptionGroupInfo} from './OptionGroups.style';
import {BASKET_MODE} from '../../constants/constant';

export class OptionGroupsSingle extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedCount: 0
    };
    this.selectOption = this.selectOption.bind(this);
    this.shouldBeChecked = this.shouldBeChecked.bind(this);
  }

  componentWillMount() {
    let defaultSelected = 0;
    const {basketModalMode, selectedSizeChanged, optionGroup, updateOptionGroups, selectedOptions} = this.props;
    if (basketModalMode === BASKET_MODE.CREATE || selectedSizeChanged){
      optionGroup.options.map(option => {
        if (option.defaultOption) {
          defaultSelected += 1;
          updateOptionGroups({
            group: optionGroup.name,
            selection: option.name,
            price: option.price
          }, optionGroup.multiSelect);
        }
      });
    } else {
      selectedOptions.map(option => {
        if (option.group === this.props.optionGroup.name) {
          defaultSelected += 1;
        }
      });
    }
    this.setState({selectedCount: defaultSelected});
  }

  componentWillReceiveProps(nextProps) {
    const {selectedSizeChanged} = nextProps;
    if (selectedSizeChanged) {
      this.setState({selectedCount: 0});
    }
  }

  selectOption(updatedOption, multiSelect, isChecked) {
    const {updateOptionGroups, optionGroup} = this.props;
    const newCount = isChecked
      ? (optionGroup.maxSelectable === 1 ? 1 : this.state.selectedCount + 1)
      : this.state.selectedCount - 1;
    this.setState({selectedCount: newCount}, () =>
      updateOptionGroups(updatedOption, multiSelect, optionGroup.maxSelectable === 1)
    );
  }

  shouldBeChecked(option) {
    const {optionGroup, selectedOptions, selectedSizeChanged, basketModalMode} = this.props;
    if (basketModalMode === BASKET_MODE.CREATE && selectedSizeChanged) {
      return option.defaultOption;
    }
    return selectedOptions.some(selectedOption =>
      selectedOption.group === optionGroup.name && selectedOption.selection === option.name);
  }

  render() {
    const {optionGroup, selectedSizeChanged} = this.props;
    const renderOptionGroup = optionGroup &&
      optionGroup.options.map(option => {
        const isChecked = this.shouldBeChecked(option);
        return (
          <Option
            key={option.name}
            option={option}
            optionGroupName={optionGroup.name}
            multiSelect={optionGroup.multiSelect}
            isEnabled={!(this.state.selectedCount >= optionGroup.maxSelectable && optionGroup.multiSelect) || optionGroup.maxSelectable < 2}
            selectedSizeChanged={selectedSizeChanged}
            isChecked={isChecked}
            onChange={this.selectOption}
          />);
      }
    );

    const renderSelectionDescription = optionGroup.multiSelect && optionGroup.maxSelectable > 0 &&
      <OptionGroupInfo>{this.state.selectedCount} of {optionGroup.maxSelectable}</OptionGroupInfo>;

    return (
      <div>
        <OptionGroupWrapper key={optionGroup.name}>
          <OptionGroupName
            data-rw="basket-modal--option-group--name"
            data-rw-meta={`basket-modal--option-group ${optionGroup.name}`}
          >{optionGroup.name}</OptionGroupName>
          {renderSelectionDescription}
          <OptionGroupStyled>
            {renderOptionGroup}
          </OptionGroupStyled>
        </OptionGroupWrapper>
      </div>
    );
  }
}

OptionGroupsSingle.propTypes = {
  optionGroup: PropTypes.object.isRequired,
  updateOptionGroups: PropTypes.func.isRequired,
  selectedOptions: PropTypes.array,
  basketModalMode: PropTypes.string,
  selectedSizeChanged: PropTypes.bool.isRequired
};

export default OptionGroupsSingle;



// WEBPACK FOOTER //
// ./components/Meal/OptionGroupSingle.js